module.exports = __webpack_public_path__ + "static/media/lob-5612-logo.76bba72f.png";